import { render, staticRenderFns } from "./ColumnsSelector.vue?vue&type=template&id=39f4997a&"
import script from "./ColumnsSelector.vue?vue&type=script&lang=js&"
export * from "./ColumnsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports